export default __webpack_public_path__ + "static/media/element_7.e970bb32.webp";